import(/* webpackMode: "eager" */ "/tmp/8de9b0a15bd30af/app/[locale]/error.tsx");
